import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { EmailAddressFindAndFix } from './EmailAddressFindAndFix';
import { PersonUpdate } from './PersonUpdate';
import { UserDisplay } from './UserDisplay';
import { UserSearch } from './UserSearch';
import { Four04 } from 'gossamer-front-end';

export const UserRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/display/:key" element={<UserDisplay />} />
    <Route path="/email-address-find-fix" element={<EmailAddressFindAndFix />} />
    <Route path="/search" element={<UserSearch />} />
    <Route path="/update-person/:key" element={<PersonUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
